import React from 'react';
import PropTypes from 'prop-types';

import { SimpleSelector } from '../SimpleSelector';

const TimeSelector = (props) => {
  const {
    times,
    field,
    handleSelected,
    handleSelectorToggled,
    outOfRange,
    enableAllTimes,
    shouldDisableTime,
    placeholder,
  } = props;
  const options = () => {
    // TODO: filter out upper lower ranges using first and last props.times
    const timeOptions = [];

    // For UX reasons we display the options for 12am-8:55am at the bottom of the list
    const priorityHours = [
      9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
    ];
    const laterHours = [0, 1, 2, 3, 4, 5, 6, 7, 8];
    const hours = [...priorityHours, ...laterHours];

    hours.forEach((hourValue) => {
      let hour = hourValue % 12;
      const noon = Math.floor(hourValue / 12);
      hour = hour === 0 ? 12 : hour;

      [
        '00',
        '05',
        '10',
        '15',
        '20',
        '25',
        '30',
        '35',
        '40',
        '45',
        '50',
        '55',
      ].forEach((minutes) => {
        const time = `${hour}:${minutes}${noon === 1 ? ' PM' : ' AM'}`;

        // Enable all times
        if (enableAllTimes) {
          const disabled = shouldDisableTime && shouldDisableTime(time);
          if (!disabled) {
            timeOptions.push({
              label: time,
              value: time,
            });
          }
        }

        // Enable only specified times
        if (times.includes(time)) {
          timeOptions.push({
            label: time,
            value: time,
          });
        }
      });
    });

    return timeOptions;
  };

  return (
    <SimpleSelector
      field={field}
      outOfRange={outOfRange}
      onChange={handleSelected}
      styles={{ menuList: () => ({ maxHeight: 220 }) }}
      handleSelectorToggled={handleSelectorToggled}
      placeholder={placeholder}
      options={options()}
    />
  );
};

TimeSelector.defaultProps = {
  outOfRange: false,
  enableAllTimes: false,
  shouldDisableTime: () => {},
  placeholder: 'Select',
};

TimeSelector.propTypes = {
  times: PropTypes.arrayOf(PropTypes.string).isRequired,
  field: PropTypes.object.isRequired,
  handleSelected: PropTypes.func.isRequired,
  handleSelectorToggled: PropTypes.func.isRequired,
  outOfRange: PropTypes.bool,
  enableAllTimes: PropTypes.bool,
  shouldDisableTime: PropTypes.func,
  placeholder: PropTypes.string,
};

export default TimeSelector;
